import { render } from "./ExamReportTab.vue?vue&type=template&id=5390faf0&scoped=true"
import script from "./ExamReportTab.vue?vue&type=script&lang=js"
export * from "./ExamReportTab.vue?vue&type=script&lang=js"

import "./ExamReportTab.vue?vue&type=style&index=0&id=5390faf0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5390faf0"]])

export default __exports__